import { withPopover } from '@vlabs/monokit/shared/ui/popovers/withPopover';
import { SideMenuFilterItem } from '@vlabs/monokit/shared/ui/side-menu-filter-item';

import {
  LastLoginDateFilterPopover,
  UserRoleFilterPopover,
  DepartmentFilterPopover,
  UserNameFilterPopover,
  UserEmailFilterPopover,
  UserIdFilterPopover,
  DateCreatedFilterPopover,
} from './popovers';

const withLeftPopover = withPopover({ placement: 'left' });

const withSideMenuItemLeftPopover = withLeftPopover(SideMenuFilterItem);

export const LastLoginDateFilterWithLeftPopover = withSideMenuItemLeftPopover(LastLoginDateFilterPopover);
export const UserRoleFilterWithLeftPopover = withSideMenuItemLeftPopover(UserRoleFilterPopover);
export const DepartmentFilterWithLeftPopover = withSideMenuItemLeftPopover(DepartmentFilterPopover);
export const UserNameFilterWithLeftPopover = withSideMenuItemLeftPopover(UserNameFilterPopover);
export const UserEmailFilterWithLeftPopover = withSideMenuItemLeftPopover(UserEmailFilterPopover);
export const UserIdFilterWithLeftPopover = withSideMenuItemLeftPopover(UserIdFilterPopover);
export const DateCreatedFilterWithLeftPopover = withSideMenuItemLeftPopover(DateCreatedFilterPopover);
